import * as ROUTES from "../../Router/hotel-group-routes";
import * as HOTEL_GROUPS from "../../Router/hotel-group-routes";
import handleErrors from "./utils";
import {
  fetchHotelGroups,
  hotelGroupsListError,
  hotelGroupsListRequest,
  hotelGroupsListRequestReceived,
} from "./hotel-groups";
import {
  IS_IN_PROGRAMME_LIST_ERROR,
  IS_IN_PROGRAMME_LIST_REQUEST,
  IS_IN_PROGRAMME_LIST_REQUEST_RECEIVED,
  IS_IN_PROGRAMME_UNLOAD,
  MY_PREFERRED_PROGRAMMES_ERROR,
  PREFERRED_PROGRAMMES_RECEIVED,
  PREFERRED_PROGRAMMES_REQUEST,
  UNLOAD_MY_PREFERRED_PROGRAMMES,
} from "../reducers/types";
import axios from "axios";

export const addGroupToPreferredProgramme = (token, group, agency, company) => {
  return dispatch => {
    return axios
      .post(
        window.API +
          ROUTES.API.PREFERRED_PROGRAMMES.ADD_GROUP.replace(":id", group),
        {
          agency: agency,
          company: company,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response => {
        if (response && response.data) {
          return response.data
        }
      })
      .catch(error => {
        handleErrors(error);
      });
  };
};

export const isInProgrammeListRequest = () => ({
  type: IS_IN_PROGRAMME_LIST_REQUEST,
});

export const isInProgrammeListRequestReceived = data => ({
  type: IS_IN_PROGRAMME_LIST_REQUEST_RECEIVED,
  data,
});

export const isInProgrammeListError = error => ({
  type: IS_IN_PROGRAMME_LIST_ERROR,
  error,
});

export const myPreferredProgrammesRequest = () => ({
  type: PREFERRED_PROGRAMMES_REQUEST,
});

export const myPreferredProgrammesReceived = data => ({
  data,
  type: PREFERRED_PROGRAMMES_RECEIVED,
});

export const myPreferredProgrammesError = error => ({
  error,
  type: MY_PREFERRED_PROGRAMMES_ERROR,
});

export const unloadMyPreferredProgrammes = () => ({
  type: UNLOAD_MY_PREFERRED_PROGRAMMES,
});

export const isInProgrammeUnload = () => ({
  type: IS_IN_PROGRAMME_UNLOAD,
});
export const fetchIsInProgramme = (token, agency = null, company = null) => {
  return dispatch => {
    dispatch(isInProgrammeListRequest());
    return axios
      .get(
        `${window.API}/api/preferred-programmes/is-in-programme/?${
          agency ? `agency=${agency.value}` : ""
        }${company ? `company=${company.value}` : ""}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(response => {
        dispatch(isInProgrammeListRequestReceived(response.data));
        if (response && response.data) {
        }
      })
      .catch(error => {
        dispatch(isInProgrammeListError(error));
        handleErrors(error);
      });
  };
};

export const fetchMyPreferredProgrammes = token => {
  return dispatch => {
    dispatch(myPreferredProgrammesRequest());
    return axios
      .get(window.API + HOTEL_GROUPS.API.MY_PREFERRED_PROGRAMMES, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        dispatch(myPreferredProgrammesReceived(response.data));
      })
      .catch(error => {
        dispatch(myPreferredProgrammesError(error));
      });
  };
};
